module.exports = __webpack_public_path__ + "img/40.3a57d613.png";